import api from './client';
import type { FiltrosCatalogo, GerarCatalogoResponse } from '../types/catalogo';
import { logError } from '../utils/clientLog';

export interface CatalogoHistorico {
  id: number;
  nomeArquivo: string;
  tamanhoBytes: number;
  geradoPor?: string;
  criadoEm: string;
}

class CatalogoService {

  async listarHistorico(): Promise<CatalogoHistorico[]> {
    const response = await api.get<CatalogoHistorico[]>('/catalogo/historico');
    return response.data;
  }

  async excluirCatalogo(id: number): Promise<void> {
    await api.delete(`/catalogo/historico/${id}`);
  }

  async gerarCatalogo(filtros: FiltrosCatalogo): Promise<string> {
    try {
      const response = await api.post<GerarCatalogoResponse>('/catalogo/gerar', filtros);
      return response.data.nomeArquivo;
    } catch (error: unknown) {
      console.error('❌ Erro detalhado ao gerar catálogo:');
      if (error && typeof error === 'object' && 'response' in error) {
        const axiosError = error as { response?: { status?: number; data?: unknown }; message?: string };
        console.error('Status:', axiosError.response?.status);
        console.error('Data:', axiosError.response?.data);
        console.error('Message:', axiosError.message);
      }
      logError('Full Error:', error);
      throw error;
    }
  }

  getDownloadUrl(nomeArquivo: string): string {
    return `/api/downloads/${encodeURIComponent(nomeArquivo)}`;
  }

  /**
   * Download NATIVO do navegador — aponta um <a download> direto pro endpoint
   * (que serve com Content-Disposition: attachment e é anônimo). O navegador
   * começa na hora e mostra a própria barra de progresso.
   *
   * Antes usava axios `responseType: 'blob'`, que BUFFERIZAVA o PDF inteiro em
   * memória antes de disparar o save: o usuário ficava num wait silencioso (zero
   * feedback) até o arquivo todo transferir pelo túnel Cloudflare — daí a
   * sensação de "demora pra iniciar o download" num catálogo de vários MB.
   */
  baixarArquivo(nomeArquivo: string): void {
    const link = document.createElement('a');
    link.href = this.getDownloadUrl(nomeArquivo);
    link.download = nomeArquivo; // reforça o attachment; o server também manda
    link.rel = 'noopener';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}

export const catalogoService = new CatalogoService();